import { render, staticRenderFns } from "./MainLibraryComponent.vue?vue&type=template&id=b911e12c&scoped=true"
import script from "./MainLibraryComponent.vue?vue&type=script&lang=js"
export * from "./MainLibraryComponent.vue?vue&type=script&lang=js"
import style0 from "./MainLibraryComponent.vue?vue&type=style&index=0&id=b911e12c&prod&scoped=true&lang=css"
import style1 from "./MainLibraryComponent.vue?vue&type=style&index=1&id=b911e12c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b911e12c",
  null
  
)

export default component.exports